import { styled } from '@mui/joy';
import { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;
}

const Image = styled('img')<IProps>(({ style }) => ({
  width: 20,
  height: 20,

  ...style,
}));

export default Image;
